import { useState } from "react";
import styled from "styled-components";

import { Navigator, useStepper } from "../Stepper";
import ScoreWheel from "../components/ScoreWheel";
import { DEFAULT_SCORE } from "config";
import { colors } from "styles";
import Heading from "components/Heading";

const SmallTxt = styled.p`
  text-align: center;
  font-size: 0.9em;
  color: ${colors.darkGray};
`;

const Reason = () => {
  const { getDefault } = useStepper();
  const [score, setScore] = useState(
    getDefault("currentScore") || DEFAULT_SCORE
  );

  return (
    <>
      <Heading
        title={`¿Cuál es su puntaje de crédito actual?`}
        body={`Mueva el círculo para seleccionar su puntaje y recibir recomendaciones personalizadas.`}
      />

      <div className="text-center space-2x">
        <ScoreWheel score={score} onChange={setScore} />
      </div>

      <SmallTxt>Mueva el círculo para ajustar el puntaje de credito.</SmallTxt>

      <Navigator saveDataHandler={() => score} />
    </>
  );
};

export default Reason;
